import React, { FC } from 'react';

import { BlurIcon } from '../icons/blur';

type LobbyBlurToggleProps = {
  isBlurEnabled: boolean;
  toggleBlur: () => void;
  isSupported: boolean;
  isPreparing: boolean;
  disabled?: boolean;
};

/** Переключатель размытия фона в лобби. На браузерах без поддержки не рендерится. */
export const LobbyBlurToggle: FC<LobbyBlurToggleProps> = ({
  isBlurEnabled,
  toggleBlur,
  isSupported,
  isPreparing,
  disabled,
}) => {
  if (!isSupported) return null;

  return (
    <button
      onClick={toggleBlur}
      disabled={disabled || isPreparing}
      aria-pressed={isBlurEnabled}
      aria-label={isBlurEnabled ? 'Выключить размытие фона' : 'Размыть фон'}
      title={isBlurEnabled ? 'Выключить размытие фона' : 'Размыть фон'}
      className="relative disabled:opacity-40 disabled:cursor-not-allowed"
    >
      <BlurIcon checked={isBlurEnabled} width={36} height={36} />
      {isPreparing && (
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full" />
        </span>
      )}
    </button>
  );
};
